import { MeetingRequestViewStateHost } from '../store/schema/MeetingRequestViewState';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { action } from 'satcheljs/lib/legacy';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';
import getInitialSchedulingViewState from '../utils/getInitialSchedulingViewState';

export default action('initializeMeetingRequestViewState')(
    function initializeMeetingRequestViewState(itemViewState: MeetingRequestViewStateHost) {
        itemViewState.meetingRequestViewState = {
            editorViewState: {
                ...createEditorViewState(''),
                sendResponse: true,
            },
            groupEventAdded: false,
            responseType: 'Unknown' as ResponseTypeType,
            showProposeNewTime: true,
            schedulingViewState: getInitialSchedulingViewState(),
        };
    }
);
